import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "fw-bold mb-2" }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "text-center mt-5" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_options_selector = _resolveComponent("options-selector")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit pack",
          text: "Edit pack"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_localized_text, {
            localizedKey: "Garments",
            text: "Garments"
          })
        ]),
        _createVNode(_component_options_selector, {
          modelValue: _ctx.localModel.garmentsCalculation,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.garmentsCalculation) = $event)),
          options: _ctx.garmentsListLocal,
          keyProp: "identifier",
          labelProp: "text"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_form_field, {
          type: "number",
          tep: "1",
          labelKey: "Month Duration",
          labelValue: "Month Duration",
          placeholderKey: "Months",
          placeholderValue: "Months",
          modelValue: _ctx.localModel.monthDuration,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.monthDuration) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_form_field, {
          type: "number",
          labelKey: "Price",
          labelValue: "Price",
          placeholderKey: "Prices",
          placeholderValue: "Price",
          modelValue: _ctx.localModel.price,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.price) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_form_field, {
          type: "number",
          labelKey: "Concurrent Accesses",
          labelValue: "Concurrent Accesses",
          placeholderKey: "Concurrent Accesses",
          placeholderValue: "Concurrent Accesses",
          modelValue: _ctx.localModel.userLicense,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localModel.userLicense) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_form_field, {
          type: "number",
          labelKey: "Discount",
          labelValue: "Discount",
          placeholderKey: "Discount",
          placeholderValue: "Discount",
          modelValue: _ctx.localModel.percentageDiscount,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localModel.percentageDiscount) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.canSave,
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          (!_ctx.localModel.identifier)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Create",
                  text: "Create"
                })
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Edit",
                  text: "Edit"
                })
              ]))
        ], 8, _hoisted_10)
      ])
    ])
  ]))
}